/*
 * @Description:
 * @Date: 2025-06-05 16:30:07
 */
import router from '@/router';
import { DetailRouteQuery } from '../types';
import IndividualHouseholdList from '../views/list.vue';
import IndividualHouseholdDetail from '../views/detail.vue';

export const route = [
  {
    path: '/dbgys-individual-household/list',
    name: 'individual-household-list',
    meta: {
      title: '个体户管理'
    },
    component: IndividualHouseholdList
  },
  {
    path: '/dbgys-individual-household/detail',
    name: 'individual-household-detail',
    meta: {
      title: '个体户详情',
      parentPath: '/dbgys-individual-household/list'
    },
    component: IndividualHouseholdDetail
  }
];

export const pushDetail = (query: DetailRouteQuery) => {
  router.push({
    name: 'individual-household-detail',
    query
  });
};
